import React from 'react'
import { CDNImage } from '@front/volcanion'

import { TableCell, Tooltip, Box } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Package = ({ row }) => {
  const isB2B = !!row?.service
  const formula = !!isB2B ? row?.service?.contract?.formula.name : row?.do?.commercial_formula?.name
  const icon = row?.commercial_package?.client_type_icon
  const packageName = row?.commercial_package?.name
  return (
    <TableCell padding='none'>
      <Box display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
        <Tooltip title={packageName} placement='left'>
          <Box>
            <CDNImage name={icon} category='packages' style={{ height: 21 }} />
          </Box>
        </Tooltip>
      </Box>
      <Tooltip title={formula} placement='left'>
        <Box>
          <TextCell fontSize={13} value={formula} noWrap width='98%' />
        </Box>
      </Tooltip>
    </TableCell>
  )
}

export default React.memo(Package)
